import {GetterTree} from "vuex";
import {TarificationState} from "@/store/tarification/types";
import {RootState} from "@/store/types";

export const getters: GetterTree<TarificationState, RootState> = {
  tariffZones:state => state.tariffZones,
  tariffZone:state => state.tariffZone,
  tariffZoneGroup:state => state.tariffZoneGroup ?? Object.assign({}),
  tariffs:state => state.tariffs,
  tariff:state => state.tariff,
}